import React, { useState } from 'react'
import { Link } from 'gatsby'
import { useEffect } from 'react'
import { useContext } from 'react'
import { Collapse } from 'react-bootstrap'
import GeolocationContext from '../../contexts/geolocationContext'
import LocaleContext from '../../contexts/localeContext'
import UserContext from '../../contexts/userContext'
import { useCountries } from '../../hooks/useCountries'
import { useNavigationHome } from '../../hooks/useNavigationHome'
import { useProductSlug } from '../../hooks/slugs/useProductSlug'
import { getPriceForAccessoriesPage } from '../../services/backendApiService'
import { GetCurrencyForCountry } from '../../services/currencyService'
import { getI18nText } from '../../services/i18nService'
import { logException } from '../../services/loggingService'
import { makePartNumberUrlSafe } from '../../services/urlService'
import { isAnonymousUser } from '../../services/userService'
import { DisplayDeliveryAndStock, DisplayPrice } from '../widgets/searchResult'
import { v4 as uuid } from 'uuid'
import { useProductI18n } from '../../hooks/i18n/useProductI18n'
import LanguageContext from '../../contexts/languageContext'

const Accessories = ({ microcopy, data }) => {
  const [accessoriesOpen, setAccessoriesOpen] = useState(true)

  if (shouldShowAccessories(data)) {
    return (
      <div className="row">
        <div className="col accordion-full">
          <div className="product-details__product-data--item" id="accessories">
            <p
              className="product-details__product-data--header font__heavy"
              id="button-accessories"
            >
              <button
                className={`product-details__product-data--button ${
                  accessoriesOpen ? '' : 'collapsed'
                }`}
                type="button"
                aria-expanded={accessoriesOpen}
                onClick={() => setAccessoriesOpen(!accessoriesOpen)}
                aria-controls="accessories"
              >
                {getI18nText(microcopy, 'product.accessories')}
              </button>
            </p>
            <Collapse in={accessoriesOpen}>
              <div className="product-details__product-data--collapse">
                <div className="product-details__product-data--body is-lister">
                  <AccessoriesItems
                    items={data.pimData.accessories_fittings}
                    title={getI18nText(microcopy, 'product.accessoriesfittings')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_accessories}
                    title={getI18nText(microcopy, 'product.accessoriesaccessories')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_connectors}
                    title={getI18nText(microcopy, 'product.accessoriesconnectors')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_gauges}
                    title={getI18nText(microcopy, 'product.accessoriesgauges')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_electrical_plugs}
                    title={getI18nText(microcopy, 'product.accessorieselectricalplugs')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_manifolds}
                    title={getI18nText(microcopy, 'product.accessoriesmanifolds')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_mountings}
                    title={getI18nText(microcopy, 'product.accessoriesmountings')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_output_boards}
                    title={getI18nText(microcopy, 'product.accessoriesoutputboards')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_plates}
                    title={getI18nText(microcopy, 'product.accessoriesplates')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_service_kits}
                    title={getI18nText(microcopy, 'product.accessoriesservicekits')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_silencers}
                    title={getI18nText(microcopy, 'product.accessoriessilencers')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_similar}
                    title={getI18nText(microcopy, 'product.accessoriessimilar')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_solenoid_coils}
                    title={getI18nText(microcopy, 'product.accessoriessolenoidcoils')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_sub_bases}
                    title={getI18nText(microcopy, 'product.accessoriessubbases')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_switches}
                    title={getI18nText(microcopy, 'product.accessoriesswitches')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_tubing}
                    title={getI18nText(microcopy, 'product.accessoriestubing')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_valves}
                    title={getI18nText(microcopy, 'product.accessoriesvalves')}
                  />
                  <AccessoriesItems
                    items={data.pimData.accessories_iolink}
                    title={getI18nText(microcopy, 'product.accessoriesiolink')}
                  />
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    )
  } else {
    return null
  }
}

function shouldShowAccessories(data) {
  if (
    data.pimData &&
    (data.pimData.accessories_fittings ||
      data.pimData.accessories_accessories ||
      data.pimData.accessories_connectors ||
      data.pimData.accessories_gauges ||
      data.pimData.accessories_electrical_plugs ||
      data.pimData.accessories_manifolds ||
      data.pimData.accessories_mountings ||
      data.pimData.accessories_output_boards ||
      data.pimData.accessories_plates ||
      data.pimData.accessories_service_kits ||
      data.pimData.accessories_silencers ||
      data.pimData.accessories_similar ||
      data.pimData.accessories_solenoid_coils ||
      data.pimData.accessories_sub_bases ||
      data.pimData.accessories_switches ||
      data.pimData.accessories_tubing ||
      data.pimData.accessories_valves ||
      data.pimData.accessories_iolink)
  ) {
    return true
  } else {
    return false
  }
}

const AccessoriesItems = ({ items, title }) => {
  return (
    <>
      {items ? (
        <>
          <p className="font__bold">{title}</p>
          <div className="row grid-lister mt-4 pb-0 grid-col-4">
            {items.map((element) => {
              var product = element.split('|')
              return (
                <AccessoriesItem
                  key={product[0]}
                  partNumber={product[0]}
                  image={product[1]}
                  description={product[2]}
                />
              )
            })}
          </div>
        </>
      ) : null}
    </>
  )
}

const AccessoriesItem = ({ partNumber, description, image }) => {
  const locale = useContext(LocaleContext)
  const { email, queryingUser } = useContext(UserContext)
  const { country } = useContext(GeolocationContext)
  const { language } = useContext(LanguageContext)
  const countries = useCountries(locale)
  const [currency, setCurrency] = useState()
  const [price, setPrice] = useState()
  const [loginForPrice, setLoginForPrice] = useState()
  const [loading, setLoading] = useState(true)
  const [leadTime, setLeadTime] = useState()
  const [quantity] = useState(1)
  const [stockOnHand, setStockOnHand] = useState()
  const [quoteOnly, setQuoteOnly] = useState()
  const [accessoryDescription, setAccessoryDescription] = useState(description)
  const productMicrocopy = useProductI18n(locale)
  const imageUrl = `https://cdn.norgren.com/images/${image}`
  const productSlug =
    '/' +
    useNavigationHome(locale).slug +
    '/' +
    useProductSlug(locale) +
    '/' +
    makePartNumberUrlSafe(partNumber)

  useEffect(() => {
    function getTheProduct(partNumber, currency) {
      let requestId = uuid()
      setLoading(true)
      getPriceForAccessoriesPage(partNumber, country, currency, language, requestId)
        .then((data) => {
          if (data && data.product) {
            setLeadTime(data.product.leadTime)
            setStockOnHand(data.product.stockAmount)
            setLoginForPrice(data.loginForPricingFeature)
            setQuoteOnly(data.product.quoteOnly)
            if (data.product.price) {
              setPrice(data.product.price.amount)
              setCurrency(data.product.price.currency)
            }
          } else {
            setQuoteOnly(true)
          }
          setLoading(false)
        })
        .catch((error) => {
          logException('Search result error', error)
          setQuoteOnly(true)
          setLoading(false)
        })
    }

    import('he').then((he) => {
      if (description) {
        setAccessoryDescription(he.decode(description))
      }
    })

    if (queryingUser === false) {
      if (isAnonymousUser(email) === true && country) {
        if (currency === null || currency === undefined) {
          setCurrency(GetCurrencyForCountry(country, countries))
        } else {
          getTheProduct(partNumber, currency)
        }
      } else if (isAnonymousUser(email) === false) {
        getTheProduct(partNumber, null)
      }
    } else {
      setLoading(true)
    }
  }, [partNumber, queryingUser, email, country, currency])

  return (
    <div className="col grid-lister__item d-flex">
      <div className="grid-lister__details d-flex align-items-start flex-grow-1">
        <div className="grid-lister__image--listview-only">
          <img className="image__fit--cover no-opacity" src={imageUrl} alt={partNumber} />
        </div>
        <div className="grid-lister__container d-flex flex-column flex-grow-1">
          <div className="grid-lister__details--description">
            <h4 className="mt-0">
              <Link to={productSlug} rel="index,follow">
                {accessoryDescription !== null && accessoryDescription !== undefined
                  ? accessoryDescription
                  : null}
              </Link>
            </h4>
          </div>
          <div className="grid-lister__details--stock d-flex flex-wrap mt-4 justify-content-between font__bold">
            <p>
              {getI18nText(productMicrocopy, 'product.productcode')}: {partNumber}
            </p>
          </div>
          <div className="grid-lister__details--flipped">
            <div className="grid-lister__image">
              <img src={imageUrl} alt={partNumber} className="image__fit--cover no-opacity" />
            </div>
          </div>
          <div className="grid-lister__details--pricing d-flex flex-wrap mt-2">
            <DisplayPrice
              price={price}
              currency={currency}
              loginForPrice={loginForPrice}
              locale={locale}
              loading={loading}
              quoteOnly={quoteOnly}
            />

            <div className="grid-lister__details--buttons d-flex align-items-center flex-wrap">
              {/*<Link
                to={productSlug}
                rel="index,follow"
                className="btn btn--listview-only text-uppercase"
              >
                <div className="d-flex justify-content-center align-items-center">
                  <span> {getI18nText(productMicrocopy, 'product.more')}</span>
                </div>
              </Link>*/}
              <Link
                to={productSlug}
                rel="index,follow"
                className="btn btn-red text-uppercase add-to-basket"
              >
                <div className="d-flex justify-content-center align-items-center">
                  <span> {getI18nText(productMicrocopy, 'product.moreinfo')}</span>
                </div>
              </Link>
            </div>
          </div>
          <DisplayDeliveryAndStock
            leadTime={leadTime}
            locale={locale}
            stockOnHand={stockOnHand}
            quantity={quantity}
            loading={loading}
          />
        </div>
      </div>
    </div>
  )
}

export default Accessories
